<div id="cuentas-contrato" class="space-y-4">
  <p class="text-sm text-muted-foreground">
    Primero las opciones de pago, en el orden en que el cliente las ve en la app; dentro de cada una, sus cuentas. Cada cambio se ve al instante
    en el teléfono de la derecha, antes de guardar. Nada se escribe hasta que pulses «Guardar» y escribas el motivo.
  </p>

  <div *ngIf="error" class="kb-aviso kb-aviso-alerta"><i class="fas fa-exclamation-triangle"></i><div>{{ error }}</div></div>
  <div *ngIf="cargando && !datos" class="text-sm text-muted-foreground">Cargando cuentas…</div>
  <div *ngIf="!puedeVer" class="kb-aviso kb-aviso-info"><i class="fas fa-lock"></i><div>No tienes permiso para ver las cuentas por contrato.</div></div>

  <ng-container *ngIf="datos">
    <!-- Corte ya aplicado (P5): lo que pasó con las cuentas en el switch -->
    <div *ngIf="datos.corte" class="kb-aviso kb-aviso-alerta" id="aviso-corte">
      <i class="fas fa-info-circle"></i>
      <div>
        <div class="kb-aviso-titulo">Ya hay un corte de cuentas aplicado</div>
        Fecha: {{ datos.corte.fecha | date:'dd/MM/yyyy HH:mm' }} · Origen: {{ datos.corte.origen }}
        <span *ngIf="datos.corte.usuario"> · Quién: {{ datos.corte.usuario?.username || datos.corte.usuario }}</span>
        <span *ngIf="datos.corte.motivo"> · Motivo: {{ datos.corte.motivo }}</span>
        · {{ datos.corte.cuentas }} cuentas cambiadas. Al pasar a CT no se repite; al volver a MT se deshace.
      </div>
    </div>
    <div *ngIf="datos.aviso" class="kb-aviso kb-aviso-alerta"><i class="fas fa-exclamation-triangle"></i><div>{{ datos.aviso }}</div></div>

    <!-- Resumen -->
    <div class="kb-stat-grid" id="resumen-cuentas-contrato">
      <div class="kb-stat"><div class="kb-stat-label">Contrato que cobra</div><div class="kb-stat-valor">{{ datos.perfilCobra ? nombreContrato(datos.perfilCobra) : 'Sin leer' }}</div><div class="kb-stat-pie">Se cambia en «Contrato activo»</div></div>
      <div class="kb-stat" [ngClass]="{'kb-stat-alerta': totalCambios > 0}"><div class="kb-stat-label">Cambios sin guardar</div><div class="kb-stat-valor" id="total-cambios">{{ totalCambios }}</div><div class="kb-stat-pie">Solo en tu borrador</div></div>
      <div class="kb-stat" [ngClass]="{'kb-stat-alerta': bloqueos.length > 0}"><div class="kb-stat-label">Bloqueos</div><div class="kb-stat-valor" id="total-bloqueos">{{ bloqueos.length }}</div><div class="kb-stat-pie">Impiden guardar</div></div>
      <div class="kb-stat"><div class="kb-stat-label">Cuentas</div><div class="kb-stat-valor">{{ totalCuentas }}</div><div class="kb-stat-pie">En {{ opciones.length }} opciones de pago</div></div>
    </div>

    <!-- Secciones y acciones -->
    <div class="flex flex-wrap items-center justify-between gap-2">
      <div class="kb-tabs" role="group" aria-label="Sección">
        <button type="button" class="kb-tab" [ngClass]="{'kb-tab-activo': seccion === 'cuentas'}" (click)="abrirSeccion('cuentas')">Cuentas</button>
        <button type="button" class="kb-tab" [ngClass]="{'kb-tab-activo': seccion === 'historial'}" (click)="abrirSeccion('historial')">Historial de cambios</button>
      </div>
      <div class="kb-acciones-grupo" *ngIf="seccion === 'cuentas' && puedeCambiar">
        <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" id="b-preparar-corte" (click)="prepararElCorte()"><i class="fas fa-magic"></i> Preparar el corte del 1-nov</button>
        <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm" id="b-descartar" [disabled]="!hayBorrador" (click)="descartar()">Descartar cambios</button>
      </div>
    </div>

    <div *ngIf="avisoCorte && hayBorrador" class="kb-aviso kb-aviso-info" id="aviso-borrador-corte">
      <i class="fas fa-eye"></i>
      <div>
        <div class="kb-aviso-titulo">Es un borrador del corte: no se guardó nada</div>
        Se llenó con {{ nombreContrato(borrador.perfilSimulado) }} como el que cobra, las cuentas de CT de cada par visibles y sus pares de MT ocultos.
        Míralo en el teléfono. El contrato que cobra no cambia desde aquí: se pasa con «Pasar a {{ borrador.perfilSimulado }}» en Contrato activo, y ese botón aplica el corte de cuentas.
      </div>
    </div>
    <div *ngIf="resultado" class="kb-aviso kb-aviso-info" id="resultado-guardado"><i class="fas fa-check-circle"></i><div>{{ resultado }}</div></div>

    <!-- ===================== CUENTAS ===================== -->
    <div *ngIf="seccion === 'cuentas'" class="grid gap-6 lg:grid-cols-[minmax(0,1fr)_22rem]">
      <div class="min-w-0 space-y-4" id="cuentas-contrato-niveles">

        <!-- Filtro por etiqueta: aplica a todas las opciones -->
        <div class="flex flex-wrap items-center gap-2" id="filtro-etiquetas" aria-label="Filtrar por etiqueta">
          <span class="text-sm text-muted-foreground">Filtrar por etiqueta</span>
          <button type="button" class="kb-chip" [ngClass]="{'kb-chip-activo': !filtroEtiqueta}" (click)="filtrarPorEtiqueta(null)">Todas</button>
          <button *ngFor="let e of catalogo" type="button" class="kb-chip" [ngClass]="{'kb-chip-activo': filtroEtiqueta === e.nombre}" (click)="filtrarPorEtiqueta(e.nombre)">
            <span class="kb-punto" [style.backgroundColor]="e.color"></span>{{ e.nombre }} · {{ conteoEtiquetas[e.nombre] || 0 }}
          </button>
          <span *ngIf="!catalogo.length" class="text-xs text-muted-foreground">Todavía no hay etiquetas. Crea una desde cualquier cuenta.</span>
        </div>

        <!-- Con filtro: las cuentas con esa etiqueta, en todas las opciones -->
        <ng-container *ngIf="filtroEtiqueta">
          <div class="flex flex-wrap items-center justify-between gap-2 text-sm">
            <span>Cuentas con la etiqueta <b>«{{ filtroEtiqueta }}»</b>, en todas las opciones de pago</span>
            <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm" (click)="filtrarPorEtiqueta(null)">Quitar el filtro</button>
          </div>
          <div *ngIf="!paresFiltrados.length" class="kb-empty"><div class="kb-empty-titulo">Ninguna cuenta con esta etiqueta</div></div>
          <section *ngFor="let x of paresFiltrados; trackBy: trackPorId" class="space-y-3">
            <h4 class="kb-section-title">{{ x.opcion.title }}</h4>
            <ng-container *ngTemplateOutlet="paresTpl; context: { pares: x.pares }"></ng-container>
          </section>
        </ng-container>

        <!-- Nivel 1: las opciones de pago, en el orden de la app -->
        <ng-container *ngIf="!filtroEtiqueta && !opcionAbiertaDatos">
          <div>
            <h3 class="kb-section-title">Opciones de pago</h3>
            <p class="text-sm text-muted-foreground">Las categorías que el cliente ve al pagar, en este orden. Usa las flechas para cambiar el orden y entra a cada una para ver sus cuentas.</p>
          </div>
          <section *ngFor="let o of opciones; let i = index; let primera = first; let ultima = last; trackBy: trackPorId" class="kb-card"
            [id]="'opcion-' + o._id" [ngClass]="{'kb-con-cambios': resumen[o._id]?.conCambios, 'kb-con-bloqueo': resumen[o._id]?.bloqueos?.length, 'kb-resaltar': resaltado === 'opcion-' + o._id, 'opacity-70': !o.showClient}">
            <div class="kb-card-body flex flex-wrap items-start gap-4">
              <div class="flex flex-col items-center gap-1" aria-label="Orden en la app">
                <button type="button" class="kb-btn kb-btn-outline kb-btn-icon kb-btn-sm" [disabled]="primera || !puedeCambiar" (click)="mover(o, 'subir')" [attr.aria-label]="'Subir ' + o.title"><i class="fas fa-chevron-up"></i></button>
                <b class="text-sm">{{ i + 1 }}</b>
                <button type="button" class="kb-btn kb-btn-outline kb-btn-icon kb-btn-sm" [disabled]="ultima || !puedeCambiar" (click)="mover(o, 'bajar')" [attr.aria-label]="'Bajar ' + o.title"><i class="fas fa-chevron-down"></i></button>
              </div>
              <div class="min-w-0 flex-1 space-y-2">
                <div class="flex flex-wrap items-baseline gap-2">
                  <h4 class="kb-card-title">{{ o.title }}</h4>
                  <span class="kb-td-mono text-xs text-muted-foreground">{{ o.code }}</span>
                </div>
                <p *ngIf="o.description" class="text-sm text-muted-foreground">En la app: «{{ o.description }}»</p>
                <div class="flex flex-wrap items-center gap-1.5">
                  <span class="kb-badge kb-badge-contorno">{{ resumen[o._id]?.mt + resumen[o._id]?.ct }} cuentas · MT {{ resumen[o._id]?.mt }} · CT {{ resumen[o._id]?.ct }}</span>
                  <span *ngIf="resumen[o._id]?.elige" class="kb-badge kb-badge-neutro">
                    {{ resumen[o._id]?.visibles }} {{ resumen[o._id]?.visibles === 1 ? 'cuenta visible' : 'cuentas visibles' }}<ng-container *ngIf="resumen[o._id]?.bancosVisibles?.length">: {{ resumen[o._id]?.bancosVisibles.join(', ') }}</ng-container>
                  </span>
                  <span *ngIf="resumen[o._id]?.cobros?.length" class="kb-badge kb-badge-neutro">Cobra {{ nombreContrato(efectivo?.perfilCobra) }}</span>
                  <span *ngIf="resumen[o._id]?.bloqueos?.length" class="kb-badge kb-badge-alerta">{{ resumen[o._id]?.bloqueos.length }} {{ resumen[o._id]?.bloqueos.length === 1 ? 'bloqueo' : 'bloqueos' }}</span>
                  <span *ngIf="!resumen[o._id]?.bloqueos?.length" class="kb-badge kb-badge-exito">Sin bloqueos</span>
                  <span *ngIf="resumen[o._id]?.conCambios" class="kb-badge kb-badge-marca">Cambios sin guardar</span>
                </div>
              </div>
              <div class="flex flex-col items-end gap-2">
                <button type="button" role="switch" class="kb-interruptor" [attr.aria-checked]="!!o.showClient" [disabled]="!puedeCambiar" (click)="alternarOpcion(o)">
                  <span class="kb-interruptor-pista"></span>La ve el cliente
                </button>
                <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" (click)="abrirOpcion(o)">Ver cuentas</button>
              </div>
            </div>
          </section>
        </ng-container>

        <!-- Nivel 2: las cuentas de una opción, en pares MT → CT -->
        <ng-container *ngIf="!filtroEtiqueta && opcionAbiertaDatos as o">
          <div class="flex flex-wrap items-center gap-2 text-sm">
            <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm" (click)="volverAOpciones()"><i class="fas fa-arrow-left"></i> Opciones de pago</button>
            <span class="text-muted-foreground">/</span><b>{{ o.title }}</b><span class="kb-td-mono text-xs text-muted-foreground">{{ o.code }}</span>
            <span *ngIf="!o.showClient" class="kb-badge kb-badge-neutro">Oculta al cliente</span>
          </div>

          <!-- Cobros fijos: botones y DI -->
          <section *ngIf="resumen[o._id]?.cobros?.length" class="kb-card" [id]="'cobros-' + o._id">
            <div class="kb-card-header">
              <h4 class="kb-card-title">Cobros fijos</h4>
              <p class="kb-card-desc">El cliente no elige cuenta aquí: cada cobro usa la cuenta del contrato que cobra ({{ nombreContrato(efectivo?.perfilCobra) }}). Solo se consultan; el contrato se cambia en «Contrato activo».</p>
            </div>
            <div class="kb-card-body space-y-3">
              <div *ngFor="let co of resumen[o._id].cobros" class="rounded-lg border border-border p-3">
                <div class="mb-2 flex items-center justify-between gap-2">
                  <b>{{ nombreServicio(co.servicio) }}</b>
                  <span class="kb-badge" [ngClass]="co.par ? 'kb-badge-exito' : 'kb-badge-alerta'">{{ co.par ? 'Con su cuenta de CT' : 'Falta la cuenta de CT' }}</span>
                </div>
                <div class="grid gap-3 md:grid-cols-2">
                  <ng-container *ngTemplateOutlet="fichaTpl; context: { c: co.cuentaMT, editable: false, acciones: true }"></ng-container>
                  <ng-container *ngTemplateOutlet="fichaTpl; context: { c: co.par, editable: false, acciones: true }"></ng-container>
                </div>
              </div>
            </div>
          </section>

          <ng-container *ngIf="resumen[o._id]?.pares?.length; else sinCuentasTpl">
            <h4 class="kb-section-title">Cuentas que el cliente elige</h4>
            <ng-container *ngTemplateOutlet="paresTpl; context: { pares: resumen[o._id].pares }"></ng-container>
          </ng-container>
          <ng-template #sinCuentasTpl>
            <div *ngIf="!resumen[o._id]?.cobros?.length" class="kb-empty"><div class="kb-empty-titulo">Esta opción no tiene cuentas</div></div>
          </ng-template>
        </ng-container>
      </div>

      <!-- Columna derecha: teléfono, bloqueos y guardar -->
      <aside class="space-y-4 lg:sticky lg:top-4 lg:self-start" aria-label="Vista del cliente y guardado">
        <app-cuentas-contrato-telefono [vista]="telefono" [modo]="modoTelefono" [hayCambios]="totalCambios > 0" (modoChange)="cambiarModoTelefono($event)"></app-cuentas-contrato-telefono>

        <section class="kb-card" id="antes-de-guardar">
          <div class="kb-card-header"><h3 class="kb-card-title">Antes de guardar</h3></div>
          <div class="kb-card-body space-y-2">
            <ul *ngIf="bloqueos.length" class="space-y-2" id="lista-bloqueos">
              <li *ngFor="let b of bloqueos" class="kb-aviso kb-aviso-alerta">
                <i class="fas fa-exclamation-circle"></i>
                <div>{{ b.mensaje }}
                  <button *ngIf="textoIr(b)" type="button" class="ml-1 font-medium underline" (click)="irA(b)">{{ textoIr(b) }}</button>
                </div>
              </li>
            </ul>
            <div *ngIf="!bloqueos.length" class="kb-aviso kb-aviso-info" id="sin-bloqueos"><i class="fas fa-check-circle"></i><div>Nada bloquea. El cliente siempre tiene a dónde pagar y cada cuenta visible es del contrato que cobra.</div></div>

            <div *ngIf="frenos.length" class="space-y-2" id="frenos-switch">
              <p class="text-sm font-medium">Para el switch (no impide guardar)</p>
              <div *ngFor="let f of frenos" class="kb-aviso kb-aviso-info">
                <i class="fas fa-info-circle"></i>
                <div>{{ f.mensaje }}
                  <button *ngIf="textoIr(f)" type="button" class="ml-1 font-medium underline" (click)="irA(f)">{{ textoIr(f) }}</button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="kb-card" id="guardar">
          <div class="kb-card-header"><h3 class="kb-card-title">Guardar</h3></div>
          <div class="kb-card-body space-y-3">
            <ol *ngIf="cambios.length" class="list-decimal space-y-1 pl-5 text-sm" id="lista-cambios-resumen">
              <li *ngFor="let c of cambios">{{ c.texto }}</li>
            </ol>
            <button *ngIf="puedeCambiar" type="button" id="b-guardar" class="kb-btn kb-btn-primary w-full" [disabled]="!puedeGuardar" (click)="abrirGuardar()">
              Guardar {{ totalCambios }} {{ totalCambios === 1 ? 'cambio' : 'cambios' }}
            </button>
            <p class="text-xs text-muted-foreground" id="razon-sin-guardar" *ngIf="!puedeGuardar">{{ razonSinGuardar }}</p>
            <p class="text-xs text-muted-foreground" *ngIf="puedeGuardar">Queda guardado cómo estaba todo: en el historial puedes «Volver a este estado».</p>
          </div>
        </section>
      </aside>
    </div>

    <!-- ===================== HISTORIAL ===================== -->
    <section *ngIf="seccion === 'historial'" class="kb-card" id="historial-cambios">
      <div class="kb-card-header">
        <h3 class="kb-card-title">Historial de cambios</h3>
        <p class="kb-card-desc">Quién cambió qué, cuándo y por qué. «Volver a este estado» deja todo como estaba antes de ese cambio, si nada más lo tocó después.</p>
      </div>
      <div class="kb-card-body-plano">
        <div *ngIf="errorHistorial" class="kb-aviso kb-aviso-alerta m-4"><i class="fas fa-exclamation-triangle"></i><div>{{ errorHistorial }}</div></div>
        <div *ngIf="cargandoHistorial && !historial" class="p-4 text-sm text-muted-foreground">Cargando historial…</div>
        <div *ngIf="historial && !historial.cambios?.length" class="kb-empty"><div class="kb-empty-titulo">Todavía no se ha guardado ningún cambio</div></div>
        <div *ngIf="historial?.cambios?.length" class="kb-table-envoltorio">
          <table class="kb-table">
            <thead class="kb-thead"><tr><th class="kb-th">Cuándo</th><th class="kb-th">Quién</th><th class="kb-th">Motivo</th><th class="kb-th">Qué cambió</th><th class="kb-th kb-th-acciones"></th></tr></thead>
            <tbody>
              <tr *ngFor="let c of historial.cambios" class="kb-tr" [ngClass]="{'kb-tr-atenuada': c.revertido}">
                <td class="kb-td whitespace-nowrap">{{ fecha(c.fecha) }}</td>
                <td class="kb-td">{{ c.usuario?.username || '—' }}</td>
                <td class="kb-td">{{ c.motivo }}</td>
                <td class="kb-td">
                  <ul class="space-y-0.5 text-sm"><li *ngFor="let f of frasesDeBitacora(c)">{{ f }}</li></ul>
                  <span *ngIf="c.revertido" class="kb-badge kb-badge-neutro mt-1">Ya se volvió{{ c.usuario_vuelta?.username ? ' · ' + c.usuario_vuelta.username : '' }}{{ c.fecha_vuelta ? ' · ' + fecha(c.fecha_vuelta) : '' }}</span>
                </td>
                <td class="kb-td kb-td-acciones">
                  <button *ngIf="puedeCambiar && !c.revertido" type="button" class="kb-btn kb-btn-outline kb-btn-sm" (click)="pedirVolver(c)">Volver a este estado</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="historial?.total > historial?.limite" class="kb-pager">
          <span class="text-muted-foreground">Página {{ paginaHistorial }} de {{ totalPaginasHistorial }} · {{ historial.total }} cambios</span>
          <div class="kb-acciones-grupo">
            <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" [disabled]="paginaHistorial <= 1 || cargandoHistorial" (click)="cargarHistorial(paginaHistorial - 1)">Anterior</button>
            <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" [disabled]="paginaHistorial >= totalPaginasHistorial || cargandoHistorial" (click)="cargarHistorial(paginaHistorial + 1)">Siguiente</button>
          </div>
        </div>
      </div>
    </section>
  </ng-container>

  <!-- ===================== DIÁLOGO: GUARDAR ===================== -->
  <div *ngIf="dialogoGuardar" class="kb-modal-fondo" (keydown.escape)="cerrarGuardar()" id="dialogo-guardar">
    <div class="kb-modal kb-modal-lg" role="dialog" aria-modal="true" aria-labelledby="dlg-guardar-t">
      <div class="kb-modal-header">
        <div>
          <h3 class="kb-modal-titulo" id="dlg-guardar-t">Guardar {{ totalCambios }} {{ totalCambios === 1 ? 'cambio' : 'cambios' }}</h3>
          <p class="kb-modal-desc">Esto es lo que va a cambiar para el cliente apenas guardes.</p>
        </div>
        <button type="button" class="kb-modal-cerrar" aria-label="Cerrar" (click)="cerrarGuardar()"><i class="fas fa-times"></i></button>
      </div>
      <div class="kb-modal-body space-y-4">
        <ol class="list-decimal space-y-1 pl-5 text-sm" id="dlg-lista-cambios"><li *ngFor="let c of cambios">{{ c.texto }}</li></ol>
        <div>
          <label class="kb-label" for="motivo-guardar">Motivo (obligatorio, mínimo {{ motivoMinimo }} caracteres)</label>
          <textarea id="motivo-guardar" class="kb-textarea" rows="3" [(ngModel)]="motivo" placeholder="Ej.: Se prepara el corte del 1-nov, autorizado por gerencia"></textarea>
          <p class="kb-hint" *ngIf="!motivoValido">Faltan {{ motivoMinimo - motivo.trim().length }} caracteres.</p>
        </div>
        <div *ngIf="errorGuardar" class="kb-aviso kb-aviso-peligro" id="error-guardar"><i class="fas fa-exclamation-circle"></i><div>{{ errorGuardar }}</div></div>
        <ul *ngIf="bloqueosServidor?.length" class="space-y-2" id="bloqueos-servidor">
          <li *ngFor="let b of bloqueosServidor" class="kb-aviso kb-aviso-alerta"><i class="fas fa-exclamation-circle"></i><div>{{ b.mensaje }}</div></li>
        </ul>
      </div>
      <div class="kb-modal-footer">
        <button type="button" class="kb-btn kb-btn-ghost" [disabled]="guardando" (click)="cerrarGuardar()">Seguir editando</button>
        <button type="button" id="b-confirmar-guardar" class="kb-btn kb-btn-primary" [disabled]="!motivoValido || guardando" (click)="confirmarGuardar()">
          {{ guardando ? 'Guardando…' : 'Confirmar y guardar' }}
        </button>
      </div>
    </div>
  </div>

  <!-- ===================== DIÁLOGO: VOLVER A ESTE ESTADO ===================== -->
  <div *ngIf="cambioAVolver" class="kb-modal-fondo" (keydown.escape)="cancelarVolver()" id="dialogo-volver">
    <div class="kb-modal" role="dialog" aria-modal="true" aria-labelledby="dlg-volver-t">
      <div class="kb-modal-header">
        <div>
          <h3 class="kb-modal-titulo" id="dlg-volver-t">¿Volver a este estado?</h3>
          <p class="kb-modal-desc">Se deshace el cambio del {{ fecha(cambioAVolver.fecha) }} de {{ cambioAVolver.usuario?.username || 'alguien' }}: «{{ cambioAVolver.motivo }}».</p>
        </div>
        <button type="button" class="kb-modal-cerrar" aria-label="Cerrar" (click)="cancelarVolver()"><i class="fas fa-times"></i></button>
      </div>
      <div class="kb-modal-body space-y-3">
        <ul class="list-disc space-y-0.5 pl-5 text-sm"><li *ngFor="let f of frasesDeBitacora(cambioAVolver)">{{ f }}</li></ul>
        <p class="text-sm text-muted-foreground">Cada cuenta y opción queda exactamente como estaba antes de ese cambio. El cliente lo ve apenas confirmes.</p>
        <p *ngIf="creoCuentas(cambioAVolver)" class="text-sm text-muted-foreground" id="volver-cuenta-creada">Las cuentas CT que creó este cambio no se borran: quedan apagadas y ocultas.</p>
        <div>
          <label class="kb-label" for="motivo-volver">Motivo (opcional)</label>
          <textarea id="motivo-volver" class="kb-textarea" rows="2" [(ngModel)]="motivoVolver"></textarea>
        </div>
        <div *ngIf="explicacionVolver" class="kb-aviso kb-aviso-alerta" id="explicacion-volver">
          <i class="fas fa-exclamation-triangle"></i>
          <div><div class="kb-aviso-titulo">{{ explicacionVolver.titulo }}</div><p *ngFor="let l of explicacionVolver.lineas" class="mt-1">{{ l }}</p></div>
        </div>
      </div>
      <div class="kb-modal-footer">
        <button type="button" class="kb-btn kb-btn-ghost" [disabled]="volviendo" (click)="cancelarVolver()">Cancelar</button>
        <button type="button" id="b-confirmar-volver" class="kb-btn kb-btn-primary" [disabled]="volviendo" (click)="confirmarVolver()">{{ volviendo ? 'Volviendo…' : 'Sí, volver a este estado' }}</button>
      </div>
    </div>
  </div>

  <!-- ===================== DIÁLOGO: CLONAR COMO CT / EDITAR CT ===================== -->
  <div *ngIf="formulario as f" class="kb-modal-fondo" (keydown.escape)="cerrarFormulario()" id="dialogo-cuenta-ct">
    <div class="kb-modal kb-modal-lg" role="dialog" aria-modal="true" aria-labelledby="dlg-cuenta-t">
      <div class="kb-modal-header">
        <div>
          <h3 class="kb-modal-titulo" id="dlg-cuenta-t">{{ f.modo === 'clonar' ? 'Clonar como cuenta de CrediTotal' : (f.tmpId ? 'Editar la cuenta nueva de CrediTotal' : 'Editar cuenta de CrediTotal') }}</h3>
          <p class="kb-modal-desc">
            <ng-container *ngIf="f.modo === 'clonar'">Se copian los datos de {{ nombreDeCuenta(f.base) }}. Cambie solo lo necesario.</ng-container>
            <ng-container *ngIf="f.modo === 'editar'">{{ nombreDeCuenta(f.base) }}. Los cambios van al borrador; no se guarda nada todavía.</ng-container>
          </p>
        </div>
        <button type="button" class="kb-modal-cerrar" aria-label="Cerrar" (click)="cerrarFormulario()"><i class="fas fa-times"></i></button>
      </div>
      <div class="kb-modal-body space-y-4">
        <div *ngIf="f.modo === 'clonar' || f.tmpId" class="kb-aviso kb-aviso-info" id="aviso-nace-apagada">
          <i class="fas fa-info-circle"></i>
          <div>La cuenta nueva nace <b>apagada y oculta</b>: el cliente no la ve. Cuando esté guardada, la enciende y la muestra desde esta misma vista.</div>
        </div>

        <div class="grid gap-3 md:grid-cols-2">
          <div><label class="kb-label" for="cc-number">Número de cuenta</label><input id="cc-number" class="kb-input" type="text" [(ngModel)]="f.datos.number" /></div>
          <div><label class="kb-label" for="cc-phone">Teléfono</label><input id="cc-phone" class="kb-input" type="text" [(ngModel)]="f.datos.phone" /></div>
          <div class="md:col-span-2">
            <label class="kb-label" for="cc-bank">Banco</label>
            <div class="kb-select-envoltorio">
              <select id="cc-bank" class="kb-select" [ngModel]="f.datos.bankCode" (ngModelChange)="elegirBanco($event)">
                <option [ngValue]="null">Sin banco</option>
                <option *ngIf="f.datos.bankCode && !bancos[f.datos.bankCode]" [ngValue]="f.datos.bankCode">{{ f.datos.bankCode }}</option>
                <option *ngFor="let b of listaBancos" [ngValue]="b.bankCode">{{ b.name }} · {{ b.bankCode }}</option>
              </select>
              <span class="kb-select-flecha"><i class="fas fa-chevron-down"></i></span>
            </div>
            <p class="kb-hint" *ngIf="!listaBancos.length">No se pudo leer el catálogo de bancos; se conserva el banco actual.</p>
          </div>
          <div><label class="kb-label" for="cc-identity">Cédula o RIF del titular</label><input id="cc-identity" class="kb-input" type="text" [(ngModel)]="f.datos.identity" /></div>
          <div><label class="kb-label" for="cc-taxid">RIF de la empresa receptora</label><input id="cc-taxid" class="kb-input" type="text" [(ngModel)]="f.datos.taxId" /></div>
          <div><label class="kb-label" for="cc-name">Nombre</label><input id="cc-name" class="kb-input" type="text" [(ngModel)]="f.datos.name" /></div>
          <div><label class="kb-label" for="cc-desc">Descripción</label><input id="cc-desc" class="kb-input" type="text" [(ngModel)]="f.datos.description" /></div>
          <div><label class="kb-label" for="cc-sim">SAP · símbolo</label><input id="cc-sim" class="kb-input" type="text" [(ngModel)]="f.datos.subscriptor_simbolo" /></div>
          <div><label class="kb-label" for="cc-cta">SAP · cuenta</label><input id="cc-cta" class="kb-input" type="text" [(ngModel)]="f.datos.subscriptor_cuenta" /></div>
          <div><label class="kb-label" for="cc-mp">SAP · MP</label><input id="cc-mp" class="kb-input" type="text" [(ngModel)]="f.datos.subscriptor_mp" /></div>
        </div>

        <div>
          <div class="kb-label">Se copia sin cambios</div>
          <dl class="grid grid-cols-[auto_1fr] gap-x-3 gap-y-1 rounded-lg border border-border p-3 text-sm" id="datos-solo-lectura">
            <dt class="text-muted-foreground">Método</dt><dd>{{ f.base.metodo?.name || f.base.metodo?.code || 'Sin dato' }}</dd>
            <ng-container *ngIf="monedaDe(f.base)"><dt class="text-muted-foreground">Moneda</dt><dd>{{ monedaDe(f.base) }}</dd></ng-container>
            <dt class="text-muted-foreground">Verificación</dt><dd>{{ textoVerificacion(f.base) || 'Sin configurar' }}<span *ngIf="f.base.typeConfirm" class="ml-1 text-xs text-muted-foreground">({{ f.base.typeConfirm }})</span></dd>
            <dt class="text-muted-foreground">Contrato</dt><dd>CrediTotal (CT)</dd>
            <dt class="text-muted-foreground">Reemplaza a</dt><dd>{{ f.origen.equivale_a && !f.tmpId && f.modo === 'editar' ? f.origen.equivale_a : f.origen.code }}</dd>
          </dl>
        </div>

        <div *ngIf="f.avisoRif" class="kb-aviso kb-aviso-alerta" id="aviso-rif"><i class="fas fa-exclamation-triangle"></i><div>No se encontró el RIF de CrediTotal: revise el RIF.</div></div>
        <p class="kb-hint" *ngIf="clonIdentico" id="hint-sin-cambios">Por ahora es idéntica a la de Mundo Total. Puede agregarla así, pero revise el número, el banco y el RIF.</p>
      </div>
      <div class="kb-modal-footer">
        <button type="button" class="kb-btn kb-btn-ghost" (click)="cerrarFormulario()">Cancelar</button>
        <button type="button" id="b-aceptar-cuenta" class="kb-btn kb-btn-primary" [disabled]="!formularioListo" (click)="aceptarFormulario()">{{ textoBotonFormulario }}</button>
      </div>
    </div>
  </div>

  <!-- ===================== PLANTILLAS ===================== -->
  <!-- Una lista de pares MT → CT -->
  <ng-template #paresTpl let-pares="pares">
    <div *ngFor="let p of pares" class="grid gap-3 md:grid-cols-[1fr_auto_1fr] md:items-stretch">
      <ng-container *ngTemplateOutlet="fichaTpl; context: { c: p.mt, editable: true, acciones: true, vacio: 'Sin cuenta de Mundo Total' }"></ng-container>
      <div class="hidden items-center text-muted-foreground md:flex" aria-hidden="true"><i class="fas fa-long-arrow-alt-right"></i></div>
      <ng-container *ngTemplateOutlet="fichaTpl; context: { c: p.ct, editable: true, acciones: true, vacio: 'Sin cuenta de CrediTotal' }"></ng-container>
    </div>
  </ng-template>

  <!-- Una cuenta con todos sus datos y sus controles -->
  <ng-template #fichaTpl let-c="c" let-editable="editable" let-vacio="vacio" let-acciones="acciones">
    <div *ngIf="!c" class="flex min-h-[4rem] items-center justify-center rounded-lg border border-dashed border-border p-3 text-sm text-muted-foreground">{{ vacio || 'Sin cuenta' }}</div>
    <div *ngIf="c" [id]="'cuenta-' + c._id" class="rounded-lg border border-border bg-card p-3 text-sm"
      [ngClass]="{'kb-con-cambios': cuentaConCambios(c), 'kb-con-bloqueo': bloqueosDeCuenta(c).length, 'kb-resaltar': resaltado === 'cuenta-' + c._id}">
      <div class="flex flex-wrap items-center gap-1.5">
        <span class="kb-badge" [ngClass]="(c.perfil || 'MT') === 'MT' ? 'kb-badge-marca' : 'kb-badge-exito'">{{ c.perfil || 'MT' }}</span>
        <b>{{ nombreBanco(c) || c.metodo?.name }}</b>
        <span *ngIf="codigoBanco(c)" class="kb-td-mono text-xs text-muted-foreground">{{ codigoBanco(c) }}</span>
        <span *ngIf="c.metodo?.name" class="kb-badge kb-badge-neutro">{{ c.metodo.name }}</span>
        <span *ngIf="c.nueva" class="kb-badge kb-badge-marca">Nueva · sin guardar</span>
        <span *ngIf="!c.nueva && cuentaConCambios(c)" class="kb-badge kb-badge-marca">Cambio sin guardar</span>
        <span *ngIf="bloqueosDeCuenta(c).length" class="kb-badge kb-badge-alerta">Bloqueo</span>
      </div>
      <p *ngIf="relacion(c)" class="mt-1 text-xs text-muted-foreground">{{ relacion(c) }}</p>

      <dl class="mt-2 grid grid-cols-[auto_1fr] gap-x-3 gap-y-1">
        <dt class="text-muted-foreground">Cuenta</dt><dd class="break-all">{{ c.numero || 'Sin dato' }}</dd>
        <ng-container *ngIf="c.telefono"><dt class="text-muted-foreground">Teléfono</dt><dd>{{ c.telefono }}</dd></ng-container>
        <dt class="text-muted-foreground">Titular</dt><dd>{{ titular(c) }}</dd>
        <ng-container *ngIf="textoSap(c)"><dt class="text-muted-foreground">SAP</dt><dd>{{ textoSap(c) }}</dd></ng-container>
        <ng-container *ngIf="monedaDe(c)"><dt class="text-muted-foreground">Moneda</dt><dd>{{ monedaDe(c) }}</dd></ng-container>
        <dt class="text-muted-foreground">Verificación</dt>
        <dd [ngClass]="{'kb-texto-alerta': !textoVerificacion(c)}">{{ textoVerificacion(c) || 'Sin configurar' }}<span *ngIf="c.typeConfirm" class="ml-1 text-xs text-muted-foreground">({{ c.typeConfirm }})</span></dd>
      </dl>

      <div class="mt-3 flex flex-wrap gap-x-4 gap-y-2">
        <button type="button" role="switch" class="kb-interruptor" [attr.aria-checked]="!!c.showClient" [disabled]="!editable || !puedeCambiar || c.nueva" (click)="alternarMostrar(c)">
          <span class="kb-interruptor-pista"></span>La ve el cliente
        </button>
        <button type="button" role="switch" class="kb-interruptor" [attr.aria-checked]="c.status !== false" [disabled]="!editable || !puedeCambiar || c.nueva" (click)="alternarEncendida(c)">
          <span class="kb-interruptor-pista"></span>Encendida
        </button>
        <button type="button" role="switch" class="kb-interruptor" [attr.aria-checked]="!!c.showChatbot" [disabled]="!editable || !puedeCambiar || c.nueva" (click)="alternarChatbot(c)">
          <span class="kb-interruptor-pista"></span>Chatbot
        </button>
      </div>

      <p *ngIf="c.nueva" class="mt-2 text-xs text-muted-foreground">Nace apagada y oculta: no le llega al cliente. Se enciende y se muestra después, cuando ya esté guardada.</p>

      <div *ngIf="acciones && puedeCambiar && (puedeClonar(c) || !esMT(c))" class="mt-3 flex flex-wrap gap-2 border-t border-border pt-2">
        <button *ngIf="puedeClonar(c)" type="button" class="kb-btn kb-btn-outline kb-btn-sm" [id]="'b-clonar-' + c._id" (click)="abrirClonar(c)"><i class="fas fa-clone"></i> Clonar como CT</button>
        <button *ngIf="!esMT(c)" type="button" class="kb-btn kb-btn-outline kb-btn-sm" [id]="'b-editar-' + c._id" (click)="abrirEditar(c)"><i class="fas fa-pen"></i> Editar</button>
        <button *ngIf="c.nueva" type="button" class="kb-btn kb-btn-ghost kb-btn-sm" [id]="'b-quitar-' + c._id" (click)="quitarDelBorrador(c)">Quitar del borrador</button>
      </div>

      <div class="mt-3 border-t border-border pt-2">
        <div class="mb-1 text-xs font-medium text-muted-foreground">Etiquetas internas</div>
        <app-cuentas-contrato-etiquetas [etiquetas]="c.etiquetas || []" [catalogo]="catalogo" [editable]="editable && puedeCambiar && !c.nueva"
          (agregar)="agregarEtiqueta(c, $event)" (quitar)="quitarEtiqueta(c, $event)" (creada)="etiquetaCreada($event)"></app-cuentas-contrato-etiquetas>
      </div>
    </div>
  </ng-template>
</div>
